const otpActionsPrefix = 'OTP';

export const GET_OTP_START = `${otpActionsPrefix}/GET_PAGE_START`;
export const GET_OTP_SUCCESS = `${otpActionsPrefix}/GET_PAGE_SUCCESS`;
export const GET_OTP_FAIL = `${otpActionsPrefix}/GET_PAGE_FAIL`;

export const VERIFY_OTP_START = `${otpActionsPrefix}/VERIFY_OTP_START`;
export const VERIFY_OTP_SUCCESS = `${otpActionsPrefix}/VERIFY_OTP_SUCCESS`;
export const VERIFY_OTP_FAIL = `${otpActionsPrefix}/VERIFY_OTP_FAIL`;
export const RESET_VERIFY_OTP_ERROR = `${otpActionsPrefix}/RESET_VERIFY_OTP_ERROR`;

export const RESEND_OTP_START = `${otpActionsPrefix}/RESEND_OTP_START`;
export const RESEND_OTP_SUCCESS = `${otpActionsPrefix}/RESEND_OTP_SUCCESS`;
export const RESEND_OTP_FAIL = `${otpActionsPrefix}/RESEND_OTP_FAIL`;

export const RESET_OTP_STATE = `${otpActionsPrefix}/RESET_OTP_STATE`;
